import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoordinadorRoutingModule } from './coordinador-routing.module';
import { CargaComponent } from './carga/carga.component';
import { DespliegueComponent } from './despliegue/despliegue.component';
import { CoordinadorComponent } from './coordinador.component';
import { EstadisticasComponent } from './estadisticas/estadisticas.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { FileDropModule } from 'ngx-file-drop';
import { PipesModule } from '../shared/pipes/pipes.module';
import { AWSService } from '../shared/services/aws.service';
import { MetricasGlobalesComponent } from './estadisticas/metricas-globales/metricas-globales.component';
import { ArchivosConErrorPipe } from '../shared/pipes/archivosConError.pipe';
import { FiltrosCargaComponent } from './carga/filtros/filtros.component';
import { FiltrosDespliegueComponent } from './despliegue/filtros/filtros.component';
import { MetricasEmpresaComponent } from './estadisticas/metricas-empresa/metricas-empresa.component';

@NgModule({
  declarations: [
    CargaComponent,
    FiltrosCargaComponent,
    FiltrosDespliegueComponent,
    DespliegueComponent,
    CoordinadorComponent,
    EstadisticasComponent,
    MetricasGlobalesComponent,
    MetricasEmpresaComponent
  ],
  providers: [AWSService, ArchivosConErrorPipe],
  imports: [
    CommonModule,
    SharedModule,
    CoordinadorRoutingModule,
    FormsModule,
    FileDropModule,
    PipesModule
  ]
})
export class CoordinadorModule {}
